import { createType, get } from '../../utils/apiHelpers'
import Auth0Manager from '../../utils/auth0Manager'
import {
  FAILURE_TYPE,
  REQUEST_TYPE,
  SUCCESS_TYPE,
  SET_HIGH_SCHOOL_SITE_ID_TYPE,
  SET_ELEMENTARY_SITE_ID_TYPE,
  SET_MIDDLE_SCHOOL_SITE_ID_TYPE,
  SET_DIGITAL_WELL_BEING_SITE_ID_TYPE,
} from './types'

export async function fetchUserContext(dispatch, secondStepDomain, options) {
  const token = await Auth0Manager.getAccessToken()
  // If no options influencing path or adaptation are provided, use existing flow
  if (
    !options ||
    (options?.adaptResponse == null && options?.contextPath === undefined)
  ) {
    dispatch(getUserContext(secondStepDomain, token))
    return
  }

  // LEARN-driven branch with optional path + adapter
  const url = createEndpoint(
    secondStepDomain,
    options?.contextPath || 'context',
  )
  // REQUEST
  dispatch({ type: REQUEST_TYPE })
  try {
    const raw = await simpleFetchUserContext(url, token)
    const payload = options?.adaptResponse ? options.adaptResponse(raw) : raw
    // SUCCESS with payload expected by reducer
    dispatch({ type: SUCCESS_TYPE, payload })
  } catch (err) {
    // FAILURE with error expected by reducer
    dispatch({ type: FAILURE_TYPE, error: err })
    throw err
  }
}

export async function fetchUserContextWithToken(
  dispatch,
  secondStepDomain,
  token,
  options,
) {
  if (
    !options ||
    (options?.adaptResponse == null && options?.contextPath === undefined)
  ) {
    dispatch(getUserContext(secondStepDomain, token))
    return
  }

  const url = createEndpoint(
    secondStepDomain,
    options?.contextPath || 'context',
  )
  // REQUEST
  dispatch({ type: REQUEST_TYPE })
  try {
    const raw = await simpleFetchUserContext(url, token)
    const payload = options?.adaptResponse ? options.adaptResponse(raw) : raw
    // SUCCESS with payload expected by reducer
    dispatch({ type: SUCCESS_TYPE, payload })
  } catch (err) {
    // FAILURE with error expected by reducer
    dispatch({ type: FAILURE_TYPE, error: err })
    throw err
  }
}

export const fetchUserContextReduxConnect = (secondStepDomain, options) => {
  return async dispatch => {
    return fetchUserContext(dispatch, secondStepDomain, options)
  }
}

export const getUserContext = (secondStepDomain, token) => {
  const fullUrl = createEndpoint(secondStepDomain)
  const typesOrdered = [
    createType(REQUEST_TYPE),
    createType(SUCCESS_TYPE),
    createType(FAILURE_TYPE),
  ]
  return get(fullUrl, typesOrdered, token)
}

export const createEndpoint = (secondStepDomain, contextPath = 'context') => {
  const url = `${secondStepDomain}${contextPath}`
  return url
}

const getAuthorization = token => {
  if (!token) {
    console.warn('No token provided for authorization')
    return null
  }
  return token?.startsWith('Bearer ') ? token : `Bearer ${token}`
}

export async function simpleFetchUserContext(secondStepDomain, token) {
  const response = await fetch(secondStepDomain, {
    headers: {
      Authorization: getAuthorization(token),
    },
  })
  return response.json()
}

export const setHighSchoolSiteContext = siteId => {
  return async dispatch => {
    dispatch(createType(SET_HIGH_SCHOOL_SITE_ID_TYPE, { siteId }))
  }
}

// For backward compatibility
export const setSiteContext = setHighSchoolSiteContext

export const setElementarySiteContext = siteId => {
  return async dispatch => {
    dispatch(createType(SET_ELEMENTARY_SITE_ID_TYPE, { siteId }))
  }
}

export const setMiddleSchoolSiteContext = siteId => {
  return async dispatch => {
    dispatch(createType(SET_MIDDLE_SCHOOL_SITE_ID_TYPE, { siteId }))
  }
}

export const setDigitalWellBeingSiteContext = siteId => {
  return async dispatch => {
    dispatch(createType(SET_DIGITAL_WELL_BEING_SITE_ID_TYPE, { siteId }))
  }
}

export default {
  fetchUserContext,
  fetchUserContextWithToken,
  fetchUserContextReduxConnect,
  setHighSchoolSiteContext,
  setSiteContext, // Keep for backward compatibility
  setElementarySiteContext,
  setMiddleSchoolSiteContext,
  setDigitalWellBeingSiteContext,
}
